import lzmaWorker from 'lzma/src/lzma_worker.js'
import atob from 'atob'
import base64url from 'base64url'

const lzma = lzmaWorker.LZMA

export interface XSZResult<T = string | null> {
  ok: boolean
  data: T
}

export function decodeAndDecompress(payload: string): XSZResult {
  try {
    // 1. Decode the Base64 payload to a binary string
    const binaryString = atob(payload)

    // 2. Convert the binary string directly to a byte array (Uint8Array)
    const bytes = Uint8Array.from(binaryString, (char: string) => char.charCodeAt(0))

    // 3. Decompress the byte array
    const decompressedData = lzma.decompress(bytes)

    return { ok: true, data: decompressedData }
  } catch (e) {
    console.error('Decompression failed:', e)
    return { ok: false, data: null }
  }
}

export function base64urlEncode(payload: string): XSZResult {
  const result: XSZResult = { ok: true, data: null }
  try {
    result.data = base64url.encode(payload)
  } catch (e) {
    console.log(e)
    result.ok = false
  }
  return result
}

export function base64urlDecode(payload: string): XSZResult {
  const result: XSZResult = { ok: true, data: null }
  try {
    result.data = base64url.decode(payload)
  } catch (e) {
    console.log(e)
    result.ok = false
  }
  return result
}